import { formatDate } from './emailUtils';

function EmailUnsubscribes({
  addForm,
  onAdd,
  onDelete,
  onUpdateAddForm,
  submitting,
  unsubscribes,
}) {
  return (
    <div className="admin-panel admin-email-unsubscribes">
      <div className="admin-page__header--split">
        <h2>Unsubscribed emails</h2>
        <span className="admin-email-badge">{unsubscribes.length} total</span>
      </div>
      <form className="admin-email-inline-form" onSubmit={onAdd}>
        <input
          name="email"
          onChange={onUpdateAddForm}
          placeholder="email@example.com"
          type="email"
          value={addForm.email}
        />
        <input
          name="reason"
          onChange={onUpdateAddForm}
          placeholder="Reason or note"
          value={addForm.reason}
        />
        <button className="btn btn--primary" disabled={submitting || !addForm.email.trim()} type="submit">
          Add
        </button>
      </form>
      <div className="admin-email-unsubscribe-table">
        {unsubscribes.map((record) => (
          <div className="admin-email-unsubscribe-row" key={record._id}>
            <span>{record.email}</span>
            <span>{record.source || 'footer'}</span>
            <span>{formatDate(record.unsubscribedAt)}</span>
            <span>{record.reason || 'No reason'}</span>
            <button onClick={() => onDelete(record._id)} type="button">
              Remove
            </button>
          </div>
        ))}
      </div>
      {unsubscribes.length === 0 ? <p className="admin-empty">No unsubscribes yet.</p> : null}
    </div>
  );
}

export default EmailUnsubscribes;
